import { AbstractControl } from '@angular/forms';

export const isControlsIsValid = (controls: {
  [key: string]: AbstractControl;
}): boolean => {
  let isValid = true;

  Object.keys(controls).forEach(key => {
    if (controls[key].errors) {
      isValid = false;
    }
  });

  return isValid;
};
